import type { ReactElement } from 'react';
import { Box } from 'components/ui';
import type { AuthResendLabelProps } from './AuthResendLabel.props';

// Buttons and status links in the auth flow uppercase their text, which would render the
// countdown as "(10S)"; the suffix opts back out so it reads "(10s)".
const AuthResendLabel = ({ label, remainingSeconds }: AuthResendLabelProps): ReactElement => {
  if (!remainingSeconds) {
    return <>{label}</>;
  }

  return (
    <>
      {`${label} `}
      <Box component="span" sx={{ textTransform: 'lowercase' }}>
        {`(${remainingSeconds}s)`}
      </Box>
    </>
  );
};

export default AuthResendLabel;
